function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Error_svg__1_a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F06A57"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#DE2612"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 13,
  fill: "#DE2612",
  opacity: 0.14
}), React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 8,
  fill: "#FFF"
}), React.createElement("path", {
  fill: "url(#Error_svg__1_a)",
  d: "M13 5a8 8 0 017.996 7.75L21 13a8 8 0 01-7.75 7.996L13 21a8 8 0 010-16zm0 10.752a1.25 1.25 0 00-1.244 1.122l-.006.128.006.127a1.25 1.25 0 001.116 1.116l.128.007.128-.007A1.25 1.25 0 0013 15.752zM12.174 8l-.084.006c-.192.03-.338.169-.34.335v.02l.38 5.815.013.067c.049.15.215.259.41.257h.893l.082-.006c.185-.028.33-.157.342-.318l.38-5.816-.005-.07c-.031-.158-.194-.283-.397-.29h-1.674z"
}));

var SvgError = function SvgError(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _ref, _ref2);
};

export default SvgError;